/**
 * 用户邀请状态
 */
enum AcceptStatus {
    邀请中 = 'ACCEPT_ING',
    已拒绝 = 'ACCEPT_NO',
    已邀请 = 'ACCEPT_YES',
}

export default AcceptStatus;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/AcceptStatus/index.ts